import React, { Component } from 'react'
import UserList from './List'
import { Layout } from 'antd'
import { Container, Row, Col } from 'reactstrap'
import Header from '../Header'

class User extends Component {
  render () {
    return (
      <Layout className='layout'>
        <Header item='user' />
        <div className='main-content' ref='mainContent'>
          <Container fluid>
            <Row className='mt-5 mb-5 content-auto'>
              <Col className='mb-5 mb-xl-0' xl='12'>
                <UserList />
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>
    )
  }
}

export default User
